import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    storage: {
      getItem: (key) => {
        try {
          return localStorage.getItem(key);
        } catch {
          return null;
        }
      },
      setItem: (key, value) => {
        try {
          localStorage.setItem(key, value);
        } catch {
          console.warn('Failed to save auth state to localStorage');
        }
      },
      removeItem: (key) => {
        try {
          localStorage.removeItem(key);
        } catch {
          console.warn('Failed to remove auth state from localStorage');
        }
      },
    },
  },
});

// Create a promise that resolves when the initial session is loaded
export const sessionInitialized = supabase.auth.getSession().then(({ data, error }) => {
  if (error) {
    throw error;
  }
  return data.session;
});